module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0042.jpg?v=c16e794f";